import { Component, OnInit, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { AppViewDirective } from '../../app-view.directive';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { UserService } from 'src/services/user.service';
import { MiscService } from 'src/services/misc.service';
import { EventBusService } from 'src/services/event-bus.service';
import { IncidentsComponent } from 'src/components/incidents/incidents.component';
import { ManufacturerDashboardComponent } from 'src/components/manufacturer-dashboard/manufacturer-dashboard.component';
import { EditProfileComponent } from 'src/components/edit-profile/edit-profile.component';
import { ItemsReceivedComponent } from 'src/components/items-received/items-received.component';
import { ItemsSentComponent } from 'src/components/items-sent/items-sent.component';
import { MatDrawer } from '@angular/material';
import { RequestNotificationDialogComponent } from '../../../components/request-notification-dialog/request-notification-dialog.component';
import { MatDialog } from '@angular/material/dialog';

import { NotificationsService } from 'src/services/notifications.service';
import { RedirectService } from 'src/services/redirect.service';
import { SidenavbarViewService } from '../../../services/sidenavbar-view.service';

@Component({
  selector: 'app-distributor',
  templateUrl: './distributor.component.html',
  styleUrls: ['./distributor.component.css']
})
export class DistributorComponent implements OnInit, OnDestroy {

	@ViewChild(AppViewDirective, {static: true}) appViewHost: AppViewDirective;
	role: any;
	view: any;
	labels: any;
	subcriptions: any[] = [];
	@ViewChild('drawer', { static: false}) drawer: MatDrawer;

  	constructor(
    	private componentFactoryResolver: ComponentFactoryResolver,
		private router: Router,
		private route: ActivatedRoute,
		private globalCfgService: GlobalCfgService,
		private userService: UserService,
		private miscService: MiscService,
		private ebService: EventBusService,
		private notifyService: NotificationsService,
		private dialog: MatDialog,
		private redirectService: RedirectService,
		private sidenavbarViewService: SidenavbarViewService
  	) { }

  	ngOnInit() {
    	var user = this.globalCfgService.getLoggedInUser();

		this.route.parent.url.subscribe((url) => {
			var v = url.values();
			//always the first part is role
			this.role = v.next().value.path;
		});

		this.route.url.subscribe((url)=> {
			var v = url.values();
			this.view = v.next().value.path;
			this.sidenavbarViewService.childView = this.view;
		});
			

		if (!user || Object.keys(user).length == 0) {
			this.router.navigateByUrl('/');
		} else {

			this.userService.getUserDetail(user['userId']).subscribe(
				(response: any) => {
					this.globalCfgService.setFullUserObj(response);

					if (response.role == 'distributor') {
						window.localStorage.setItem('gcp', response.gcp);
						this.miscService.getLabels(response.gcp).subscribe(
						(labels: any[])=> {
							this.labels = JSON.parse(labels[0].value);
							this.globalCfgService.setSettings({
								labels: this.labels
							});

							// this.miscService.getACL(response.gcp).subscribe(
							// 	(acls: any[])=> {
							// 		var acl = JSON.parse(acls[0].value);

							// 		this.globalCfgService.setAcl(acl);
									if (this.redirectService.redirectUrl != null) {
										this.redirectService.processRedirect(this.role);
									} else {
										this.ebService.onReadySource.next();
									}
							// 	}
							// );

						});
					}
					
				});
		}

		this.subcriptions.push(this.ebService.toggleDrawerValue$.subscribe(
			drawer => {
				this.drawer.opened = drawer;
			}
		));

		this.subcriptions.push(this.ebService.onReadyValue$.subscribe(
			()=> {
				var cmpMap = {
					'dashboard': ManufacturerDashboardComponent,
					'incidents': IncidentsComponent,
					"items-received": ItemsReceivedComponent,
					"items-sent": ItemsSentComponent,
					'manage-profile': EditProfileComponent,
				};
		
				var type = this.route.data['value']['type'];
		
				let componentFactory;
		
				if (!type) {
					componentFactory = this.componentFactoryResolver.resolveComponentFactory(ManufacturerDashboardComponent);
				} else {
					componentFactory = this.componentFactoryResolver.resolveComponentFactory(cmpMap[type]);
				}
		
				const viewContainerRef = this.appViewHost.viewContainerRef;
				viewContainerRef.clear();
		
				let componentRef = viewContainerRef.createComponent(componentFactory);
			}
		));

		// if (Notification.permission === 'default') {
		// 	this.showRequestDialog();
		// } else if (Notification.permission === 'granted') {
		// 	// console.log('notifications allowed');
		// 	this.notifyService.requestPermission();
		// 	this.notifyService.receiveMessage();
		// }
  	}

	// showRequestDialog() {
	// 	const dialogRef = this.dialog.open(RequestNotificationDialogComponent, {
	// 		width: "450px"
	// 	})
	  
	// 	dialogRef.afterClosed().subscribe(result => {
	// 		console.log("The dialog was closed", result);
	// 		if (result.enable === true) {
	// 		  this.enableNotifications();
	// 		}
	// 	});
	// }

	// enableNotifications() {
	// 	this.notifyService.requestPermission();
	// 	this.notifyService.receiveMessage();
	// }

  	ngOnDestroy() {
		this.subcriptions.forEach(s => s.unsubscribe());
	}
}
